import { getStaticImageUrl } from '@utils/createImageUrl';

const Top = ({ isMobile }: { isMobile?: boolean }) => {
  return (
    <div className="for-lawyer__top-banner-content">
      <div className="for-lawyer-mobile-profile-image" />
      <div className="for-lawyer-mobile-profile-price-image" />
      <div className="for-lawyer-mobile-profile-price-law-image" />
      <div className="for-lawyer-top-banner-vlog__title">
        {isMobile ? (
          <img src={getStaticImageUrl({ fileName: 'preview/vlog.png' })} className="for-lawyer-top-banner-vlog" />
        ) : (
          <img
            src={getStaticImageUrl({ fileName: 'preview/vlog-desktop.png' })}
            className="for-lawyer-top-banner-vlog"
          />
        )}
        <h1 className="for-lawyer-top-banner-vlog-title">김법률 변호사 브이로그</h1>
      </div>
    </div>
  );
};

export default Top;
